import type { MouseEventHandler } from 'react'
import { memo, useCallback } from 'react'
import { useIntl } from 'react-intl'
import TextButton from 'LuxKit/Button/TextButton'
import LineShoppingCartIcon from 'LuxKit/Icons/line/LineShoppingCartIcon'
import Expander from 'components/utils/Expander'

interface Props {
  includesFlights: boolean
  isLoyaltyPackageUpgradeApplied?: boolean
  disabled?: boolean
  onCtaClick: (shouldAddToCart: boolean) => void
}

function PropertyAvailableRateOptionCtas({ includesFlights, isLoyaltyPackageUpgradeApplied, disabled, onCtaClick }: Props) {
  const intl = useIntl()
  const onClick = useCallback<MouseEventHandler<HTMLButtonElement>>(event => {
    const shouldAddToCart = !!event.currentTarget.dataset.addToCart
    onCtaClick(shouldAddToCart)
  }, [onCtaClick])

  return <>
    {!includesFlights && <TextButton
      onClick={onClick}
      disabled={disabled}
      kind="primary"
      size="large"
    >
      {intl.formatMessage({
        id: 'QtRwxjRixW1FwB_2XnzB',
        defaultMessage: 'Book now',
        description: 'Primary CTA button text to book property rate option',
      })}
    </TextButton>}
    {includesFlights && <TextButton
      onClick={onClick}
      disabled={disabled}
      kind="primary"
      size="large"
    >
      {intl.formatMessage({
        id: 'eQZhf50wT1bL4oCojC_J',
        defaultMessage: 'Select package',
        description: 'CTA text when flights are included in property rate option',
      })}
    </TextButton>}
    {!includesFlights && <Expander expanded={!isLoyaltyPackageUpgradeApplied}>
      <TextButton
        onClick={onClick}
        disabled={disabled}
        kind="secondary"
        startIcon={<LineShoppingCartIcon />}
        size="large"
        fit="flex"
        data-add-to-cart
      >
        {intl.formatMessage({
          id: 'Sp8Q-ZMQBm-e_QqcwVuz',
          defaultMessage: 'Add to cart',
          description: 'Secondary CTA button text to add property rate option to cart',
        })}
      </TextButton>
    </Expander>}
  </>
}

export default memo(PropertyAvailableRateOptionCtas)
